import { render } from "./RateLimitDetails.vue?vue&type=template&id=5ef260ba"
import script from "./RateLimitDetails.vue?vue&type=script&lang=js"
export * from "./RateLimitDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__